import React from 'react'
import {Icon} from '@chakra-ui/react'

const GalleryBucketFeaturesIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" {...props}>
            <path
                d="M8.86328 7.99573L11.0881 9.08073L10.0031 11.3056"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.60842 4.39127C9.36499 3.41756 8.99018 2.59951 8.52638 2.02966C8.06259 1.45982 7.52831 1.16092 6.984 1.16677C6.43968 1.17262 5.90704 1.483 5.44634 2.06278C4.98563 2.64257 4.61524 3.46863 4.37706 4.44752C4.13888 5.42642 4.04241 6.51908 4.09858 7.60192C4.15474 8.68476 4.36129 9.71455 4.69487 10.5748C5.02844 11.4351 5.47573 12.0915 5.98613 12.4698C6.49653 12.8481 7.04968 12.9332 7.58301 12.7155"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.7158 6.41665C12.4565 5.78139 11.7812 5.20745 10.7967 4.7855C9.81212 4.36355 8.57447 4.11765 7.27924 4.08665C5.98401 4.05565 4.70504 4.24132 3.6444 4.61432C2.58377 4.98732 1.80193 5.52639 1.42242 6.14635C1.04291 6.76632 1.08735 7.43184 1.54874 8.03777C2.01013 8.64369 2.86215 9.15548 3.97019 9.49227C5.07823 9.82906 6.37912 9.97165 7.66733 9.89752C8.95554 9.82338 10.1576 9.53675 11.0837 9.0829"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default GalleryBucketFeaturesIcon
